import { PayloadAction } from '@reduxjs/toolkit';

export const reducers = {
  setLimit(state, action: PayloadAction<number>) {
    state.limit = action.payload;
  },
  setOffset(state, action: PayloadAction<number>) {
    state.offset = action.payload;
  },
  setPage(state, action: PayloadAction<number>) {
    state.page = action.payload;
  },
  setTotalPages(state, action: PayloadAction<number>) {
    state.totalPages = action.payload;
  },
};
